// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d5686a02","679":"c694d9b0"}[chunkId] + ".chunk.js";
};